import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {H2H} from "../h2h-widget.consts";

export class H2hWidgetTabChangeHandler extends ActionHandler {
  type = H2H.ACTION_TYPES.tabChangeH2h;

  async action(params){
    this.store.setActiveTab(params.index);
  }
}
